<ion-card>
  <ion-card-header>
    <ion-card-title>Étlap</ion-card-title>
    <ion-card-subtitle>
      A beszállító heti Excelje (dátum, nap, „"A" Menü”, étel) alapján a szülő a rendelésnél, a diák az
      <b>Étlap</b> menüpontban látja, mi lesz az ebéd. A rendelt adagszám oszlopot a rendszer nem olvassa.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="etlap-vezerlok">
      <ion-select *ngIf="tobbHely" fill="outline" label="Beszállító" labelPlacement="stacked" interface="popover"
                  placeholder="Válassz" [ngModel]="hely" (ngModelChange)="helyValtas($event)">
        <ion-select-option *ngFor="let h of helyek" [value]="h.id">{{ h.nev }}</ion-select-option>
      </ion-select>
      <label class="etlap-fajl">
        <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
               (change)="fajlValasztas($event)" #fajlMezo>
      </label>
      <ion-spinner name="dots" *ngIf="fut"></ion-spinner>
    </div>
    <ion-note class="etlap-megj">
      Egy fájlban több hét is lehet. A feltöltés csak a fájlban szereplő napokat cseréli le, a többi nap étlapja
      megmarad. A menü-jelet („A”, „B”) a rendszer a beszállító azonos nevű menüjéhez párosítja.
    </ion-note>

    <ng-container *ngIf="elonezet">
      <div class="etlap-figy" *ngIf="elonezet.figyelmeztetesek?.length">
        <ul><li *ngFor="let f of elonezet.figyelmeztetesek">{{ f }}</li></ul>
      </div>
      <ion-note class="etlap-megj">
        <b>{{ elonezet.fajl }}</b> — {{ elonezet.sorok?.length || 0 }} menü, {{ elonezetNapok }} nap
        <span *ngIf="elonezet.hely_nev"> · beszállító: <b>{{ elonezet.hely_nev }}</b></span>
      </ion-note>
      <div class="etlap-tabla-doboz" *ngIf="elonezet.sorok?.length">
        <table class="etlap-tabla">
          <thead>
            <tr><th>Dátum</th><th>Nap</th><th>Menü</th><th>Étel</th><th>Párosítva</th><th>Figyelmeztetés</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of elonezet.sorok; trackBy: trackSor" [class.van-figy]="s.figyelmeztetes?.length">
              <td>{{ s.datum }}</td>
              <td>{{ s.nap }}</td>
              <td><b>{{ s.menu_nev }}</b></td>
              <td>{{ s.leiras }}</td>
              <td [class.nem-parositott]="!s.menu">{{ s.menu_cim || 'nincs ilyen menü' }}</td>
              <td class="figy">{{ (s.figyelmeztetes || []).join(' ') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="margin-top:10px">
        <ion-button size="small" color="success" (click)="feltoltes()" [disabled]="!feltoltheto">
          <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>{{ ment ? 'Feltöltés…' : 'Feltöltés' }}
        </ion-button>
        <ion-button size="small" fill="outline" color="medium" (click)="megse(); fajlMezo.value = ''">Mégse</ion-button>
        <ion-note color="warning" *ngIf="tobbHely && !hely" style="font-size:.85rem">
          Válaszd ki, melyik beszállító étlapja.
        </ion-note>
      </div>
    </ng-container>

    <h3 style="font-size:1rem;margin:18px 0 4px">A következő hetek étlapja</h3>
    <ion-spinner name="dots" *ngIf="listaFut"></ion-spinner>
    <ion-note class="etlap-megj" *ngIf="!listaFut && !lista.length">Még nincs feltöltött étlap erre az időszakra.</ion-note>
    <div class="etlap-tabla-doboz" *ngIf="lista.length">
      <table class="etlap-tabla">
        <thead><tr><th style="width:90px">Menü</th><th>Étel</th><th>Párosítva</th><th></th></tr></thead>
        <tbody>
          <ng-container *ngFor="let s of lista; let i = index; trackBy: trackSor">
            <tr class="etlap-lista-nap" *ngIf="ujNap(i)"><td colspan="4">{{ napCim(s) }}</td></tr>
            <tr>
              <td><ion-input fill="outline" [(ngModel)]="$any(s)._menu_nev" aria-label="Menü"></ion-input></td>
              <td><ion-input fill="outline" [(ngModel)]="$any(s)._leiras" aria-label="Étel"></ion-input></td>
              <td [class.nem-parositott]="!s.menu">
                {{ s.menu_cim || 'nincs ilyen menü' }}<span *ngIf="tobbHely && s.hely_nev"> ({{ s.hely_nev }})</span>
              </td>
              <td class="muvelet">
                <ion-button size="small" color="success" [disabled]="!valtozott(s)" (click)="sorMentes(s)" title="Mentés">
                  <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                </ion-button>
                <ion-button size="small" color="danger" fill="outline" (click)="sorTorles(s)" title="Törlés">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="etlap-uj">
      <ion-input fill="outline" type="date" label="Nap" labelPlacement="stacked" [(ngModel)]="uj.datum"></ion-input>
      <ion-input fill="outline" label="Menü" labelPlacement="stacked" placeholder="A" [(ngModel)]="uj.menu_nev"
                 style="max-width:110px"></ion-input>
      <ion-input class="szeles" fill="outline" label="Étel" labelPlacement="stacked"
                 placeholder="Tojásos nokedli, fejes saláta" [(ngModel)]="uj.leiras"></ion-input>
      <ion-button size="small" color="primary" (click)="ujSor()">
        <ion-icon slot="start" name="add"></ion-icon>Felvétel
      </ion-button>
    </div>
    <ion-note class="etlap-megj">Ha arra a napra és menüre már van étel, a felvétel felülírja.</ion-note>
  </ion-card-content>
</ion-card>
